import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export type Cadence = 'weekly' | 'biweekly';

export type SeriesOccurrence = {
  occurrenceIndex: number;
  scheduledAt: Date;
};

export type GenerateOpts = {
  cadence: Cadence;
  dayOfWeek: number;
  timeOfDay: string;
  startDate: string;
  endDate: string;
  timezone: string;
};

export function generateSeriesOccurrences(opts: GenerateOpts): SeriesOccurrence[] {
  const stepDays = opts.cadence === 'weekly' ? 7 : 14;
  const time = normalizeTimeOfDay(opts.timeOfDay);
  const endDate = opts.endDate;
  let cursor = advanceToWeekday(dayjs(opts.startDate), opts.dayOfWeek);
  const out: SeriesOccurrence[] = [];
  let index = 0;
  while (cursor.format('YYYY-MM-DD') <= endDate) {
    const wallClock = `${cursor.format('YYYY-MM-DD')} ${time}`;
    out.push({
      occurrenceIndex: index,
      scheduledAt: dayjs.tz(wallClock, opts.timezone).toDate(),
    });
    index++;
    cursor = cursor.add(stepDays, 'day');
  }
  return out;
}

function advanceToWeekday(d: dayjs.Dayjs, targetDayOfWeek: number): dayjs.Dayjs {
  const current = d.day();
  const diff = (targetDayOfWeek - current + 7) % 7;
  return d.add(diff, 'day');
}

function normalizeTimeOfDay(t: string): string {
  const parts = t.split(':');
  if (parts.length === 2) {
    return `${t}:00`;
  }
  return t;
}
